/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_Format_MarkdownInputs */

const cs_templates_ai_format_markdown = /** @type {(inputs: Templates_Ai_Format_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown`)
};

const en_templates_ai_format_markdown = /** @type {(inputs: Templates_Ai_Format_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown`)
};

/**
* | output |
* | --- |
* | "Markdown" |
*
* @param {Templates_Ai_Format_MarkdownInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_format_markdown = /** @type {((inputs?: Templates_Ai_Format_MarkdownInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_Format_MarkdownInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_format_markdown(inputs)
	return cs_templates_ai_format_markdown(inputs)
});